import { getLocalized } from '../locales';
function monthNameBuilder({
  format,
  locale
}) {
  const requestedLocale = getLocalized(locale);
  const returnValue = [];
  for (let m = 0; m < 12; m++) {
    returnValue.push(requestedLocale.month(m, {
      width: format
    }));
  }
  return returnValue;
}
export default monthNameBuilder;